// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3JZNB","errorLogs":"styles_errorLogs__W2Kie"};